<template>
  <div>
    <h3 style="margin-bottom: 10px;">{{this.$t('form.image')}}-Template</h3>
    <AppInput :has-error="titleIsEmpty" :value="stepObject.title" @input-changed="emitTitleChangedEvent" type="text" :label="this.$t('title')" :placeholder="this.$t('placeholderTitle')"></AppInput>
    <AppInput :value="stepObject.description" @input-changed="emitDescriptionChangedEvent" type="text" :label="this.$t('form.description')" :placeholder="this.$t('placeholderDescription')"></AppInput>

    <div class="form-wrapper-file">
      <label>{{ $t('uploadFile') }}</label>
      <input accept="image/jpeg" type="file" @change="imageFileUploaded">
    </div>

    <div class="image-wrapper">
      <img style="max-height: 200px; width: auto" :src="imageSrc" :alt="imageSrc" >
    </div>
    <Loader :show="this.showLoader"></Loader>
  </div>

</template>

<script>

import AppInput from "../form/inputs/AppInput";
import {S3FileManager} from "@/mixins/s3-file-manager/s3-file-manager";
import Loader from "../loader/Loader";

export default {
  name: "ImageEditors",
  components: {AppInput, Loader},

  props:{
    stepObject: Object,
    moduleId: String,
    courseId: String
  },

  data(){
    return{
      imageSrc : '',
      s3Directory: '',
      showLoader: false,
      titleIsEmpty: false,
    }
  },

  methods:{
    emitTitleChangedEvent(title){
      if(title.target.value === undefined || title.target.value === '' || title.target.value === null){
        this.titleIsEmpty = true;
      }else{
        this.titleIsEmpty = false;
        this.$emit("step-title-changed", title);
      }
    },

    emitDescriptionChangedEvent(description){
      this.$emit("step-description-changed", description);
    },

    checkURLForValidImage(prefix) {
      return new Promise((resolve =>{
        const s3FileManager = new S3FileManager();
        s3FileManager.checkIfListExists(prefix).then(res => {
          resolve(res.length > 0);
        })
      }))
    },

    setDefaultImage(){
      this.imageSrc = "";
    },

    setInstructionImage(){
      const s3FileManager = new S3FileManager();
      s3FileManager.getSignedURL("course/" + this.courseId + "/" + this.moduleId + "/" + this.stepObject.id + "/image.jpeg").then(url=>{
        this.imageSrc = url;
      })
    },

    imageFileUploaded(event){
      const file = event.target.files[0];
      const path = "course/" + this.courseId + "/" + this.moduleId + "/" + this.stepObject.id + "/image.jpeg";
      this.imageSrc = URL.createObjectURL(file);
      const s3FileManager = new S3FileManager();
      s3FileManager.uploadFile(file, path);
    },
  },

  mounted() {
    // this is our s3 directory where all image templates - if any - are stored.
    this.s3Directory = "course/" + this.courseId + "/" + this.moduleId + "/" + this.stepObject.id;
    this.showLoader = true;
    this.checkURLForValidImage(this.s3Directory).then(fileExists => {
      this.showLoader = false;
      if (fileExists){
        this.setInstructionImage();
      } else {
        this.setDefaultImage();
      }
    })

  }
}
</script>

<style>
  .image-wrapper{
    max-width:100%;
    margin-top:24px;
    border:1px dashed lightgrey;
    border-radius:5px;
    min-height:100px;
  }
</style>
